window.addEventListener('geoMapsLoaded', () => {
    geocoderReady = true;
});

function initAutocomplete() {
    document.querySelectorAll('.manual-address-input').forEach(function(input) {
        if (input instanceof HTMLInputElement) {
            const autocompleteInstance = new google.maps.places.Autocomplete(input, {
                types: ['address'],
                componentRestrictions: { country: ['us'] },
            });
            // Store the autocomplete instance on the input element
            input.autocompleteInstance = autocompleteInstance;
        }
    });
}

function initMap() {
    document.addEventListener('DOMContentLoaded', () => {
        geocoder = new google.maps.Geocoder();
        window.onload = initMap;
    });
}

// Main DOMContentLoaded handler
/**
 * Show element(s) by removing 'display: none' inline style.
 * @param {HTMLElement|HTMLElement[]} elements
 */
function show(elements) {
    if (!elements) return;

    const nodes = (elements instanceof NodeList || Array.isArray(elements)) ? elements : [elements];

    nodes.forEach(el => {
        if (el.style.display === 'none') {
            el.style.removeProperty('display');
        }
    });
}

/**
 * Hide element(s) by setting display to none.
 * @param {HTMLElement|HTMLElement[]} elements
 */
function hide(elements) {
    if (!elements) return;
    if (Array.isArray(elements) || elements instanceof NodeList) {
        elements.forEach(el => el.style.display = 'none');
    } else {
        elements.style.display = 'none';
    }
}

/**
 * Initialize all delivery address functionality.
 */
function initDeliveryAddress() {
    initMap();
    initAutocomplete();

    const event = new Event('geoMapsLoaded');
    window.dispatchEvent(event);

    const savedAddress = getSavedDeliveryAddress();

    toggleDeliveryOverview(savedAddress, customerAddress);

    // Update address widget on initial load
    updateAddressDetailsWidget();

    // Show manual address form
    deliveryAddress.manualAddressBtn?.addEventListener('click', () => {
        showManualAddressForm();
    });

    // Back from manual address form
    deliveryAddress.manualAddressBackBtn?.addEventListener('click', () => {
        const savedAddress = getSavedDeliveryAddress();
        hide(deliveryAddress.addressFormPopups);
        deliveryAddress.delivery?.classList.remove('active');

        if (savedAddress) {
            show(deliveryAddress.deliveryOverview);
            hide(deliveryAddress.shippingOverview);
            hide(deliveryAddress.delivery);
            if (deliveryAddress.selectedAddressEl) deliveryAddress.selectedAddressEl.textContent = savedAddress;
        } else {
            show(deliveryAddress.deliveryPrompt, 'flex');
            show(deliveryAddress.shippingOverview);
        }
    });

    // Save manual address
    document.querySelectorAll('.address-form-popup').forEach(popup => {
        popup.querySelectorAll('.save-address-btn').forEach(btn => {
            btn.addEventListener('click', () => saveManualAddress(btn));
        });
    });


    // Delivery change: show new address form
    if (deliveryAddress.delivery && deliveryAddress.newAddressForm) {
        hide(deliveryAddress.newAddressForm);
        deliveryAddress.delivery.addEventListener('click', () => show(deliveryAddress.newAddressForm));
    }

    // Hide/show elements for "add new address" link
    if (deliveryAddress.customerDeliveryChange && deliveryAddress.addNewAddressLink && deliveryAddress.deliveryOverview) {
        deliveryAddress.customerDeliveryChange.addEventListener('click', () => {
            hide(deliveryAddress.deliveryOverview.querySelectorAll('.copy, .buttons-wrap'));
            show(deliveryAddress.addNewAddressLink);
        });

        deliveryAddress.addNewAddressLink.addEventListener('click', () => {
            show(deliveryAddress.deliveryOverview.querySelectorAll('.copy, .buttons-wrap'));
            hide(deliveryAddress.addNewAddressLink);
            if (deliveryAddress.newAddressForm) hide(deliveryAddress.newAddressForm);
        });
    }

    storeCustomerAddress(true);
}
function showManualAddressForm() {
    show(deliveryAddress.addressFormPopups);
    hide(deliveryAddress.deliveryPrompt);
    hide(deliveryAddress.shippingOverview);
    deliveryAddress.delivery?.classList.add('active');
}

// Use current location for address input
function useLocationLink(e) {
    e.preventDefault();

    if (!navigator.geolocation) return;

    // Find the closest .address-form-popup to the clicked link
    const formPopup = e.currentTarget.closest('.address-form-popup');
    if (!formPopup) return;

    const input = formPopup.querySelector('.manual-address-input');
    if (!input) return;

    navigator.geolocation.getCurrentPosition(position => {
        const geocoder = new google.maps.Geocoder();
        const latlng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
        };

        geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === 'OK' && results[0]) {
                input.value = results[0].formatted_address;
                usedAddress = 'geoLocation';
            } else {
                console.warn('Geocoding failed:', status);
            }
        });
    }, error => {
        console.warn('Geolocation error:', error.message);
    });
}


/**
 * Show/hide delivery overview based on saved/customer address.
 * @param {string|null} savedAddress
 * @param {boolean} customerAddress
 */
function toggleDeliveryOverview(savedAddress, customerAddress) {
    if (savedAddress || customerAddress) {
        show(deliveryAddress.deliveryOverview);
        hide(deliveryAddress.shippingOverview);
        hide(deliveryAddress.delivery);

        if (deliveryAddress.getLocationEl) hide(deliveryAddress.getLocationEl);
        if (deliveryAddress.getDeliveryEl) show(deliveryAddress.getDeliveryEl);
    } else {
        if (deliveryAddress.getLocationEl) show(deliveryAddress.getLocationEl);
        if (deliveryAddress.getDeliveryEl) hide(deliveryAddress.getDeliveryEl);
    }

    if (savedAddress && deliveryAddress.selectedAddressEl) deliveryAddress.selectedAddressEl.textContent = savedAddress;
}

/**
 * Save manual address handler.
 * @param {HTMLElement} btn
 */
function saveManualAddress(btn) {
    const formPopup = btn.closest('.address-form-popup');
    if (!formPopup) return;

    const input = formPopup.querySelector('.manual-address-input');
    if (!(input instanceof HTMLInputElement)) return;

    const address = input.value.trim();

    // Show error if input is empty
    if (!address) {
        showAddressError(formPopup, "You need to enter the address to continue");
        return;
    } else {
        clearAddressError(formPopup);
    }

    localStorage.setItem('delivery-address', address);

    // Geocode address
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
        if (status === 'OK' && results[0]) {
            const coords = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
            localStorage.setItem("delivery-address-coordinates", JSON.stringify(coords));
            // console.log('saveManualAddress');
            checkGopuffStatus();
            usedAddress = 'manual';
        }
    });

    const place = input.autocompleteInstance?.getPlace();
    const full_address = place && extractFullAddress(place);
    // console.log(full_address);

    if (full_address && full_address.province) {
        localStorage.setItem('delivery-address-full', JSON.stringify(full_address));
        // Set global state
        setStateOnClick(full_address.province, false);
        sessionStorage.setItem('state_global', full_address.province, false);
    } else {
        localStorage.removeItem('delivery-address-full');
    }

    hide(deliveryAddress.addressFormPopups);
    hide(deliveryAddress.shippingOverview);
    hide(deliveryAddress.delivery);

    if (deliveryAddress.selectedAddressEl) {
        deliveryAddress.selectedAddressEl.textContent = address;
        updateAddressDetailsWidget(deliveryAddress.selectedAddressEl);
    } else {
        updateAddressDetailsWidget();
    }
    deliveryAddress.deliveryOverview?.classList.remove('active');
    show(deliveryAddress.deliveryOverview);

    const modal = bootstrap.Modal.getInstance(formPopup.closest('.modal'));
    modal?.hide();
}

/**
 * Get coordinates for logged-in customer default address
 */
function checkDeliveryAddressCoordinates() {
    setTimeout(() => {
        const address = localStorage.getItem("delivery-address");
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results[0]) {
                const coords = {
                    lat: results[0].geometry.location.lat(),
                    lng: results[0].geometry.location.lng()
                };
                localStorage.setItem("delivery-address-coordinates", JSON.stringify(coords));
                checkGopuffStatus(false);
                usedAddress = 'manual';
            }
        });
    }, 500);
}

/**
 * Wait for geocoder to be ready
 */
function runWhenGeocoderReady(callback) {
    if (geocoderReady) {
        callback();
    } else {
        window.addEventListener('geoMapsLoaded', () => {
            callback();
        }, { once: true });
    }
}

/**
 * Displays an error message related to a manual address input inside the specified container.
 * If an error element does not already exist, it creates one and appends it to the container.
 * @param {HTMLElement} container - The DOM element that will contain the error message.
 * @param {string} message - The error message to display.
 */
function showAddressError(container, message) {
    let errorEl = container.querySelector('.manual-address-error');
    if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'manual-address-error';
        errorEl.style.color = 'red';
        errorEl.style.marginTop = '8px';
        container.appendChild(errorEl);
    }
    errorEl.textContent = message;
}

/**
 * Removes the manual address error message from the specified container, if it exists.
 * @param {HTMLElement} container - The DOM element that contains the error message.
 */
function clearAddressError(container) {
    const errorEl = container.querySelector('.manual-address-error');
    if (errorEl) {
        errorEl.remove();
    }
}

/**
 * Extract full address from Google Place object.
 * @param {google.maps.places.PlaceResult} place
 * @returns {{country:string,province:string,city:string,address1:string,zip:string}}
 */
function extractFullAddress(place) {
    let address1 = '', city = '', province = '', country = 'US', zip = '';

    if (!place?.address_components) return { country, province, city, address1, zip };

    place.address_components.forEach(component => {
        const { long_name, short_name, types } = component;

        if (types.includes('street_number')) address1 = long_name + ' ' + address1;
        if (types.includes('route')) address1 += long_name;
        if (types.includes('locality')) city = long_name;
        if (types.includes('administrative_area_level_1')) province = short_name;
        if (types.includes('postal_code')) zip = long_name;
    });

    return { country, province, city, address1, zip };
}

/**
 * Updates the address details widget on the page based on saved address data in localStorage.
 * Falls back to a partial address if full address data is unavailable.
 * Shows or hides the address banner accordingly.
 * @param {string} type - Type of the update (currently unused).
 */
function updateAddressDetailsWidget(type) {
    const fullAddress = localStorage.getItem('delivery-address-full');
    const partialAddress = localStorage.getItem('delivery-address');

    const pdpFullAddressEl = document.querySelector('.gopuff__details-address-full');
    const streetEl = document.querySelector('.gopuff__details-address-street');
    const cityEl = document.querySelector('.gopuff__details-address-city .city');
    const provinceEl = document.querySelector('.gopuff__details-address-city .province');
    const zipEl = document.querySelector('.gopuff__details-address-city .zip');
    const bannerEl = document.querySelector('.gopuff-banner__address');
    let pageType = window.meta.page.pageType;

    // console.log('updateAddressDetailsWidget');

    let addressObj = null;
    try {
        addressObj = fullAddress ? JSON.parse(fullAddress) : null;
    } catch {
        console.error('Invalid JSON');
    }

    // Determine if we have a valid address
    let hasAddress = false;
    const status = JSON.parse(localStorage.getItem('delivery-address-status') || '{}');
    // console.log(status.id)

    if (pdpFullAddressEl && partialAddress) pdpFullAddressEl.textContent = partialAddress;

    if (addressObj && (addressObj.address1?.trim() || addressObj.city?.trim())) {
        if (streetEl) streetEl.textContent = addressObj.address1 || '';
        if (cityEl) cityEl.textContent = addressObj.city || '';
        if (provinceEl) provinceEl.textContent = addressObj.province || '';
        if (zipEl) zipEl.textContent = addressObj.zip || '';
        hasAddress = true;
    } else if (partialAddress && !isCustomer) {
        const parts = partialAddress.split(',').map(p => p.trim()).filter(p => p);
        if (streetEl) streetEl.textContent = parts[0] || '';
        if (cityEl) cityEl.textContent = parts[1] || '';
        if (provinceEl) provinceEl.textContent = parts[2] || '';
        if (zipEl) zipEl.textContent = parts[3] || '';
        hasAddress = parts.length > 0;
    }

    toggleCommas();
    const isGopuffVariantResolved = !!document.querySelector('.product-price-data.product-price-data-pdp-gopuff')?.getAttribute('data-regular');

    // Show/hide banner based on actual address data, not DOM elements
    if (pageType === 'product' && document.querySelector('.gopuff__details-address-message')) {
        if (hasAddress && status.id !== -1 && isGopuffVariantResolved) {
            document.querySelector('.gopuff__details-address-message')?.classList.add('d-none');
            document.querySelector('.gopuff__details-address-container')?.classList.remove('d-none');
            document.querySelector('.offer-gopuff .gopuff-pdp-price-selector__button').disabled = false;
            document.querySelector('.gopuff-pdp-price-selector__price-unknown')?.classList.add('d-none');
            document.querySelector('.offer-gopuff .offer-price')?.classList.remove('d-none');
        } else {
            document.querySelector('.gopuff__details-address-message')?.classList.remove('d-none');
            document.querySelector('.gopuff__details-address-container')?.classList.add('d-none');
            document.querySelector('.offer-gopuff .gopuff-pdp-price-selector__button').disabled = true;
            document.querySelector('.gopuff-pdp-price-selector__price-unknown')?.classList.remove('d-none');
            document.querySelector('.offer-gopuff .offer-price')?.classList.add('d-none');

            if (status.id === -1 || (!isGopuffVariantResolved && hasAddress)) {
                document.querySelector('.gopuff-pdp-price-selector__price-unknown u').textContent = 'Change address';
                document.querySelector('.gopuff__details-address-message').innerHTML =
                    'Currently selected location is not supported. <u onclick="openEditAddress()">Change address</u>';
            } else if (!hasAddress) {
                document.querySelector('.gopuff-pdp-price-selector__price-unknown u').textContent = 'Change address';
                document.querySelector('.gopuff__details-address-message').innerHTML =
                    'See if you’re in the 90-min express zone<br> <u onclick="openGopuffModal()">Add an address</u>';
            }
        }
    } else if (pageType === 'collection' || pageUrlHandle === 'flaviar-black-express') {
        if (hasAddress && status.id !== -1) {
            document.querySelector('.gopuff__details-address')?.classList.add('init');
            document.querySelector('.gopuff__details-address-btn')?.classList.add('d-none');
            document.querySelector('.gopuff__details-address-container')?.classList.remove('d-none');
            if (document.querySelector('.gopuff-address-copy')) {
                document.querySelector('.gopuff-address-copy').innerHTML = "We are showing you items that deliver to:"
            }
        } else {
            document.querySelector('.gopuff__details-address')?.classList.remove('init');
            document.querySelector('.gopuff__details-address-btn')?.classList.remove('d-none');
            document.querySelector('.gopuff__details-address-container')?.classList.add('d-none');
        }
    } else if (bannerEl) {
        if (hasAddress) {
            bannerEl?.classList.remove('d-none');
        } else {
            bannerEl?.classList.add('d-none');
        }
    }

}

/**
 * Toggles the visibility of commas between city, province, and ZIP code elements
 * in the address display, hiding commas when the following field is empty.
 */
function toggleCommas() {
    const container = document.querySelector('.gopuff__details-address-city');
    if (!container) return;

    const parts = container.querySelectorAll('.city, .province, .zip');
    const commas = container.querySelectorAll('.comma');

    for (let i = 0; i < commas.length; i++) {
        const currentEl = parts[i];
        const nextEl = parts[i + 1];
        const comma = commas[i];

        if (!nextEl || !nextEl.textContent.trim()) {
            comma?.classList.add('d-none');
        } else {
            comma?.classList.remove('d-none');
        }
    }
}

// Function to handle delivery change (used by button onclick)
function deliveryChange() {
    // Show manual address form and hide other sections
    document.querySelectorAll('.address-form-popup').forEach(function(el) {
        el.style.display = 'block';
    });
    document.querySelector('.delivery-prompt').style.display = 'none';
    document.querySelector('.shipping-overview').style.display = 'none';
    document.querySelector('.delivery-overview').style.display = 'none';
    document.querySelector('.delivery').style.display = 'block';
    document.querySelector('.delivery')?.classList.add('active');
}

/**
 * Prefills the shipping address in the checkout URL for anonymous customers.
 * Runs only if `isCustomer` is true.
 */
function populateAnonymousCheckoutAddress() {
    if (isCustomer) {
        // Prefill anonymous customer address in checkout
        const checkoutLink = document.querySelector("a[href$='/checkout'], button[name='checkout']");
        if (checkoutLink) {
            checkoutLink.addEventListener("click", function (e) {
                const deliveryAddress = getDeliveryAddress();

                if (deliveryAddress) {
                    e.preventDefault();

                    const params = new URLSearchParams();

                    if (deliveryAddress.address1) {
                        params.set("checkout[shipping_address][address1]", deliveryAddress.address1);
                    }
                    params.set("checkout[shipping_address][city]", deliveryAddress.city);
                    params.set("checkout[shipping_address][province]", deliveryAddress.province);
                    params.set("checkout[shipping_address][country]", deliveryAddress.country);

                    if (deliveryAddress.zip) {
                        params.set("checkout[shipping_address][zip]", deliveryAddress.zip);
                    }

                    // Redirect to the checkout with prefilled address
                    window.location.href = `/checkout?${params.toString()}`;
                }
            });
        }
    }
}

function getSavedDeliveryAddress() {
    return localStorage.getItem('delivery-address');
}

// Handle change button click for signed-in users
// Display address list
function onChangeBtn() {
    document.querySelector('.addresses')?.classList.remove('d-none');
    document.querySelector('.buttons-wrap-container')?.classList.remove('d-none');
    document.querySelector('.delivery-default-address')?.classList.add('d-none');
    document.querySelector('.buttons-wrap-initial')?.classList.add('d-none');
}

// Retrieve anonymous customer address from autocomplete
function getDeliveryAddress() {
    const raw = localStorage.getItem("delivery-address");
    if (!raw) {
        // Always return object with empty strings if no data
        return {
            address1: "",
            city: "",
            province: "",
            zip: "",
            country: ""
        };
    }

    const parts = raw.split(",").map(part => part.trim());

    let address1 = "";
    let city = "";
    let province = "";
    let zip = "";
    let country = "";

    if (parts.length === 5) {
        [address1, city, province, zip, country] = parts;
    } else if (parts.length === 4) {
        [address1, city, province, country] = parts;

        const provinceZipMatch = province.match(/^(.+?)\s+(\d{4,})$/);
        if (provinceZipMatch) {
            province = provinceZipMatch[1].trim();
            zip = provinceZipMatch[2].trim();
        }
    } else if (parts.length === 3) {
        [city, province, country] = parts;
    }

    // Normalize US state codes
    const stateMap = {
        "alabama": "AL", "alaska": "AK", "arizona": "AZ", "arkansas": "AR", "california": "CA",
        "colorado": "CO", "connecticut": "CT", "delaware": "DE", "florida": "FL", "georgia": "GA",
        "hawaii": "HI", "idaho": "ID", "illinois": "IL", "indiana": "IN", "iowa": "IA",
        "kansas": "KS", "kentucky": "KY", "louisiana": "LA", "maine": "ME", "maryland": "MD",
        "massachusetts": "MA", "michigan": "MI", "minnesota": "MN", "mississippi": "MS", "missouri": "MO",
        "montana": "MT", "nebraska": "NE", "nevada": "NV", "new hampshire": "NH", "new jersey": "NJ",
        "new mexico": "NM", "new york": "NY", "north carolina": "NC", "north dakota": "ND",
        "ohio": "OH", "oklahoma": "OK", "oregon": "OR", "pennsylvania": "PA", "rhode island": "RI",
        "south carolina": "SC", "south dakota": "SD", "tennessee": "TN", "texas": "TX", "utah": "UT",
        "vermont": "VT", "virginia": "VA", "washington": "WA", "west virginia": "WV", "wisconsin": "WI", "wyoming": "WY"
    };

    // Normalize country codes
    const countryMap = {
        "united states": "US",
        "united states of america": "US",
        "usa": "US"
    };

    const normalizedProvince = province ? (stateMap[province.toLowerCase()] || province) : "";
    const normalizedCountry = country ? (countryMap[country.toLowerCase()] || country) : "";

    return {
        address1: address1 || "",
        city: city || "",
        province: normalizedProvince || "",
        zip: zip || "",
        country: normalizedCountry || ""
    };
}

/**
 * Sets the currently active customer address form as the default and submits it.
 */
function setDefaultCustomerAddress() {
    toggleEditAddress(true);

    const activeEditForm = document.querySelector('.edit-customer-address-form-active');

    if (activeEditForm) {
        const checkbox = activeEditForm.querySelector('input[type="checkbox"][name="address[default]"]');
        const submitBtn = activeEditForm.querySelector('button[type="submit"]');

        if (checkbox && submitBtn) {
            checkbox.checked = true;
            submitBtn.click();
        } else {
            console.warn('Checkbox or submit button not found inside the active form');
        }
    } else {
        console.warn('Active address form not found');
    }
}

/**
 * Stores the customer's delivery address in localStorage.
 * Uses liquid-provided data or extracts it from the default address element on the page.
 * @param {boolean} [useLiquidData=false] - Whether to use Liquid `customerData` instead of DOM parsing.
 */
function storeCustomerAddress(useLiquidData = false, forceReload = false) {
    try {
        let addressObject = null;

        if (useLiquidData && customerData.address1) {
            if (!customerData.address1) {
                console.warn("No address found in Liquid data.");
                return;
            }

            addressObject = customerData;
        } else {
            const defaultAddressEl = document.querySelector(".customer.addresses ul li.default-address");
            if (!defaultAddressEl) return;

            const p = defaultAddressEl.querySelector("p");
            if (!p) return;

            const lines = p.innerText.trim().split("\n").map(line => line.trim()).filter(Boolean);

            const address1 = lines[1] || "";
            const cityStateZip = lines[2] || "";
            const country = lines[3] || "";

            const match = cityStateZip.match(/^(.+?)\s+([A-Z]{2})\s+(\d{4,10})$/);

            const city = match?.[1]?.trim() || "";
            // Line positions shift with company/address2 lines, so prefer the state code Liquid put on the item
            const province = defaultAddressEl.dataset.provinceCode || match?.[2] || "";
            const zip = match?.[3] || "";

            addressObject = { country, province, city, address1, zip };

            setDefaultCustomerAddress();
        }

        localStorage.setItem("delivery-address-full", JSON.stringify(addressObject));
        // Format readable address (keep province as abbreviation)

        if (customerData) {
            const readableAddress = `${addressObject.address1}, ${addressObject.city}, ${addressObject.province}, ${addressObject.country === 'United States' ? 'USA' : addressObject.country}`;
            localStorage.setItem("delivery-address", readableAddress);
            runWhenGeocoderReady(() => {
                checkDeliveryAddressCoordinates();
            });

            // Use logged-in users address state, unless they picked a state this session
            const previousState = sessionStorage.getItem('state_global');
            const pickedState = sessionStorage.getItem('selected_state') || sessionStorage.getItem('region_id');

            // Selecting an address is a state pick too, so it outranks earlier picks after the reload
            if (!useLiquidData && addressObject.province && typeof setStateOnClick === 'function') {
                setStateOnClick(addressObject.province, false);
            }

            if (addressObject.province && (!useLiquidData || !pickedState)) {
                sessionStorage.setItem('state_global', addressObject.province, false);
            }

            // Keep the header in step and let the PDP and cart re-check coverage against the new state
            const currentState = sessionStorage.getItem('state_global');
            if (currentState && currentState !== previousState) {
                const headerState = document.getElementsByClassName('getlocation')[0];
                if (headerState) headerState.textContent = currentState;
                document.dispatchEvent(new CustomEvent("state-update", { "detail": true }));
            }
        }

        // console.log("Saved delivery address:", addressObject);

        if (forceReload) {
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    } catch (error) {
        console.error("Error in storeCustomerAddress:", error);
    }
    //confirmDelivery();
}

/**
 * Toggles visibility between the new address form and the existing address list.
 * @param {boolean} state - If true, shows the new address form; otherwise, shows existing addresses.
 */
function toggleNewAddress(state) {
    newAddressActive = state;

    if (newAddressActive) {
        resetAddressForm();
        document.querySelector('.new-customer-address-form')?.classList.remove('d-none');
        document.querySelector('.new-customer-address-form')?.classList.add('d-block');
        document.querySelector('.buttons-wrap-container')?.classList.add('d-none');
        document.querySelector('.addresses')?.classList.add('d-none');
        document.querySelector('.deliverable')?.classList.add('d-none');
    } else {
        document.querySelector('.new-customer-address-form')?.classList.add('d-none');
        document.querySelector('.new-customer-address-form')?.classList.remove('d-block');
        document.querySelector('.buttons-wrap-container')?.classList.remove('d-none');
        document.querySelector('.addresses')?.classList.remove('d-none');
        document.querySelector('.deliverable')?.classList.remove('d-none');
    }
}

/**
 * Resets the new customer address form by clearing input fields
 * and repopulating the province dropdown with the default value.
 */
function resetAddressForm() {
    const form = document.querySelector('.new-customer-address-form');
    if (!form) return;

    form.querySelectorAll('input, textarea').forEach(el => {
        if (el.tagName === 'INPUT' && (el.type === 'checkbox' || el.type === 'radio')) {
            return;
        }
        el.value = '';
    });

    // Populate province select with default value
    const provinceSelect = form.querySelector('select[name="address[province]"]');
    const selectedProvince = provinceSelect?.dataset.default || '';
    populateProvinceOptions(form, selectedProvince);
}

/**
 * Toggles the address edit form visibility and populates it with selected address data.
 * @param {boolean} state - If true, shows the edit form; otherwise, shows the address list.
 */
function toggleEditAddress(state) {
    editAddressActive = state;

    if (editAddressActive) {
        const selectedAddress = getSelectedAddressData();
        populateEditAddressForm(selectedAddress);

        document.querySelector('.edit-customer-address-form')?.classList.remove('d-none');
        document.querySelector('.edit-customer-address-form')?.classList.add('edit-customer-address-form-active');
        document.querySelector('.buttons-wrap-container')?.classList.add('d-none');
        document.querySelector('.addresses')?.classList.add('d-none');
        document.querySelector('.deliverable')?.classList.add('d-none');
    } else {
        document.querySelector('.edit-customer-address-form')?.classList.add('d-none');
        document.querySelector('.edit-customer-address-form')?.classList.remove('edit-customer-address-form-active');
        document.querySelector('.buttons-wrap-container')?.classList.remove('d-none');
        document.querySelector('.addresses')?.classList.remove('d-none');
        document.querySelector('.deliverable')?.classList.remove('d-none');
    }
}

/**
 * Retrieves address data from the default selected address form on the page.
 * @returns {Object|null} Address data object or null if not found.
 */
function getSelectedAddressData() {
    const defaultLi = document.querySelector('ul[role="list"] > li.default-address');
    if (!defaultLi) return null;

    const addressId = defaultLi.getAttribute('data-address-id');
    const formWrapper = document.getElementById(`EditAddress_${addressId}`);
    if (!formWrapper) return null;

    const form = formWrapper.querySelector('form');
    if (!form) return null;

    return {
        first_name: form.querySelector('[name="address[first_name]"]')?.value || '',
        last_name: form.querySelector('[name="address[last_name]"]')?.value || '',
        company: form.querySelector('[name="address[company]"]')?.value || '',
        address1: form.querySelector('[name="address[address1]"]')?.value || '',
        address2: form.querySelector('[name="address[address2]"]')?.value || '',
        city: form.querySelector('[name="address[city]"]')?.value || '',
        country: form.querySelector('[name="address[country]"]')?.value || '',
        province: form.querySelector('[name="address[province]"]')?.dataset.default || '',
        zip: form.querySelector('[name="address[zip]"]')?.value || '',
        phone: form.querySelector('[name="address[phone]"]')?.value || '',
        is_default: form.querySelector('[name="address[default]"]')?.checked || false,
        id: addressId
    };
}

/**
 * Fills the edit address form with the provided address data.
 * @param {Object} addressData - The address data to populate the form with.
 */
function populateEditAddressForm(addressData) {
    if (!addressData) return;

    const form = document.querySelector('.edit-customer-address-form');
    if (!form) return;

    const fields = [
        ['id', addressData.id],
        ['address[first_name]', addressData.first_name],
        ['address[last_name]', addressData.last_name],
        ['address[company]', addressData.company],
        ['address[address1]', addressData.address1],
        ['address[address2]', addressData.address2],
        ['address[city]', addressData.city],
        ['address[zip]', addressData.zip],
        ['address[phone]', addressData.phone],
    ];

    fields.forEach(([name, value]) => {
        const input = form.querySelector(`[name="${name}"]`);
        if (input) {
            input.value = '';
            input.value = value || '';
        }
    });

    const countrySelect = form.querySelector('.edit-address-country');
    if (countrySelect && addressData.country) {
        countrySelect.value = addressData.country;
        countrySelect.dispatchEvent(new Event('change'));
    }

    populateProvinceOptions(form, addressData.province);
    const defaultCheckbox = form.querySelector('[name="address[default]"]');
    if (defaultCheckbox) {
        defaultCheckbox.checked = !!addressData.is_default;
    }
}

/**
 * Populates the province/state dropdown(s) in a form with US states.
 * @param {HTMLElement} formElement - The form element containing the province select(s).
 * @param {string} [selectedProvince=''] - The state to preselect, if any.
 */
function populateProvinceOptions(formElement, selectedProvince = '') {
    if (!formElement) return;

    const provinceSelects = formElement.querySelectorAll('select[name="address[province]"]');
    if (!provinceSelects.length) return;

    const usStates = [
        "Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "Armed Forces Americas",
        "Armed Forces Europe", "Armed Forces Pacific", "California", "Colorado", "Connecticut", "Delaware",
        "District of Columbia", "Federated States of Micronesia", "Florida", "Georgia", "Guam", "Hawaii",
        "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands",
        "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska",
        "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
        "Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico",
        "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
        "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
    ];

    provinceSelects.forEach(select => {
        select.innerHTML = '';

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Select state';
        select.appendChild(placeholder);

        usStates.forEach(state => {
            const option = document.createElement('option');
            option.value = state;
            option.textContent = state;
            if (state === selectedProvince) {
                option.selected = true;
            }
            select.appendChild(option);
        });

        select.value = selectedProvince || '';
        select.dispatchEvent(new Event('change'));
    });
}

document.addEventListener('click', function (event) {
    const clickedItem = event.target.closest('ul[role="list"] > li');

    if (clickedItem) {
        const currentDefault = document.querySelector('ul[role="list"] > li.default-address');
        if (currentDefault) {
            currentDefault?.classList.remove('default-address');
        }

        clickedItem?.classList.add('default-address');
    }
});

/**
 * Initializes the address edit form with Shopify's country/province selector,
 * and sets up form submission to update the selected address via AJAX.
 */
function setupAddressForm() {
    document.addEventListener('DOMContentLoaded', function () {
        if (Shopify && Shopify.CountryProvinceSelector) {
            new Shopify.CountryProvinceSelector('edit_address_country', 'edit_address_province', {
                hideElement: null
            });
        }
    });

    const form = document.getElementById("new-address-form");
    const messageBox = document.getElementById("address-message");

    if (!form || !messageBox) return;

    form.addEventListener("submit", async (e) => {
        e.preventDefault();

        const addressData = getSelectedAddressData();
        if (!addressData) {
            messageBox.innerHTML = `<p style="color:red;">❌ No selected address found to update.</p>`;
            return;
        }

        populateEditAddressForm(addressData);
        const formData = new FormData(form);
        const addressId = addressData.id;

        try {
            const response = await fetch(`/account/addresses/${addressId}`, {
                method: "POST",
                headers: { "X-Requested-With": "XMLHttpRequest" },
                body: new URLSearchParams({
                    ...Object.fromEntries(formData),
                    "_method": "put"
                })
            });

            if (response.ok) {
                messageBox.innerHTML = `<p style="color:green;">✅ Address updated successfully</p>`;
            } else {
                const text = await response.text();
                messageBox.innerHTML = `<p style="color:red;">❌ Failed to update: ${text}</p>`;
            }
        } catch (error) {
            messageBox.innerHTML = `<p style="color:red;">⚠️ Error: ${error.message}</p>`;
        }
    });
}

function handleBlackPageSections () {
    let isBlackPage = false;
    let hideBlackSections = false;

    // Capture all the sections with "visible_default" class
    const blackPageSections = Array.from(document.querySelectorAll('.visible_default'));

    if (pageUrlHandle === "flaviar-black") {
        isBlackPage = true;
    }

    if (isBlackPage && customerAddress) {
        hideBlackSections = true;
    }
}

/**
 * Get current time in specific time zone.
 */
function getCurrentTimeInTimeZone(timeZone) {
    try {
        return new Date(new Intl.DateTimeFormat('en-US', {
            timeZone,
            hour12: false,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date()));
    } catch (error) {
        console.error(`Invalid or unsupported time zone: ${timeZone}`, error);
        return null;
    }
}

/**
 * Parse cron string like "0 8 * * *" and return Date (today's time) in that zone.
 */
function parseCronTime(cron, currentTime, timeZone) {
    const parts = cron.trim().split(' ');
    if (parts.length < 2) return null;

    const minute = parseInt(parts[0], 10);
    const hour = parseInt(parts[1], 10);

    const targetTime = new Date(currentTime);
    targetTime.setHours(hour, minute, 0, 0);
    return targetTime;
}

/**
 * Calculate the difference in minutes between two dates.
 */
function diffInMinutes(date1, date2) {
    return Math.round((date2 - date1) / 60000);
}

function formatHour(date) {
    const hours = date.getHours();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const hour12 = hours % 12 || 12; // Convert 0 -> 12
    return `${hour12}${ampm}`;
}

/**
 * Fetch and save Gopuff delivery status from stored coordinates.
 **/
function checkGopuffStatus(pdpReload = true) {
    const coordinatesJSON = localStorage.getItem('delivery-address-coordinates');
    if (!coordinatesJSON) {
        console.error('No coordinates found in "delivery-address-coordinates"');
        return;
    }

    let coordinates;
    try {
        coordinates = JSON.parse(coordinatesJSON);
    } catch {
        console.error('Invalid JSON in localStorage for coordinates');
        return;
    }

    const { lat, lng } = coordinates;
    if (typeof lat !== 'number' || typeof lng !== 'number') {
        console.error('Coordinates must have numeric lat and lng');
        return;
    }

    const url = `/apps/teacher/gopuff?lat=${lat}&lng=${lng}`;

    fetch(url)
        .then(res => {
            if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
            return res.json();
        })
        .then(data => {
            const location = data.location || {};
            const { open, delivery_enabled, id, time_zone, delivery_open_from, delivery_open_to } = location;
            const isGopuffVariantResolved = !!document.querySelector('.product-price-data.product-price-data-pdp-gopuff')?.getAttribute('data-regular');
            const firstTimeVisit = sessionStorage.getItem("firstTimeVisit");

            if (typeof id !== 'number') {
                console.warn('Missing id in response');
                return;
            }

            if (id === -1 || !isGopuffVariantResolved) {
                // console.log('Store is not in the provided location zone.');
                localStorage.setItem(
                    'delivery-address-status',
                    JSON.stringify({
                        id: id,
                        open: false,
                        delivery_enabled: false,
                        inside_zone: false,
                    })
                );

                // Reset message fields
                setPdpStoreMessage('availability', ``);
                setPdpStoreMessage('closingInfo', ``);

                updatePdpViewUI();
                if (pdpReload) {
                    window.location.reload();
                }

                if (!firstTimeVisit) {
                    sessionStorage.setItem("firstTimeVisit", "true");
                    window.location.reload();
                }

                return;
            }

            const inside_zone = true;

            if (
                typeof open === 'boolean' &&
                typeof delivery_enabled === 'boolean'
            ) {
                // Save all relevant info to localStorage
                localStorage.setItem(
                    'delivery-address-status',
                    JSON.stringify({
                        id,
                        open,
                        delivery_enabled,
                        inside_zone
                    })
                );

                /*console.log('Saved delivery address status:', {
                    id,
                    open,
                    delivery_enabled,
                    inside_zone
                });*/

                getWorkingHours().then(response => {
                    const { status, statusClass, availability } = getStoreStatusAndAvailability(response.workingHours);

                    const statusEl = document.querySelector(".gopuff-pdp-price-selector__store-info");

                    if (statusEl) statusEl.textContent = status;
                    if (statusEl && statusClass) {
                        statusEl.classList.add(statusClass);
                    }
                }).catch(err => {
                    console.error("Failed to get store status or availability:", err);
                });

                if (!firstTimeVisit) {
                    sessionStorage.setItem("firstTimeVisit", "true");
                    window.location.reload();
                }

                if (window.meta.page.pageType === 'product') {
                    updatePdpViewUI();
                    window.updateOfferContentHeights?.();
                    if (pdpReload) {
                        window.location.reload();
                    }
                }
            } else {
                console.warn('Missing open or delivery_enabled in response');
            }
        })
        .catch(err => console.error('Fetch error:', err));

    updateAddressDetailsWidget();
}

function setPdpStoreMessage(type, message) {
    const availabilityEl = document.querySelector('.gopuff__details-address-availability');
    const closingInfoEl = document.querySelector('.gopuff-pdp-price-selector__store-info');

    if (type === 'availability' && availabilityEl) {
        availabilityEl.textContent = message;
    }
    if (type === 'closingInfo' && closingInfoEl) {
        closingInfoEl.textContent = message;
    }

    if (window.meta.page.pageType === 'product' && type === 'availability') {
        window.updateOfferContentHeights?.();
    }
}

/**
 * Sets the active PDP price view.
 * @param {string} view - The view to set. Valid values: "standard", "gopuff".
 */

let activePdpPriceView = "standard";

function setPdpPriceView(view) {
    const validViews = ["standard", "gopuff"];
    if (!validViews.includes(view)) {
        console.warn(`Invalid view: ${view}.`);
        return;
    }

    activePdpPriceView = view;
    updatePdpViewUI();

    document.querySelector(`.price-${view} .exposed .form-check-input`)?.click();
}

function updatePdpViewUI() {

    // No address set yet (e.g. first visit / cleared storage) — there's no
    // location to fetch working hours for, so skip rather than error out.
    const { id: locationId } = JSON.parse(localStorage.getItem('delivery-address-status') || '{}');

    if (locationId) {
        getWorkingHours().then(response => {
            const { status, availability } = getStoreStatusAndAvailability(response.workingHours);

            const statusEl = document.querySelector(".gopuff-pdp-price-selector__store-info");
            const availabilityEl = document.querySelector(".gopuff__details-address-availability");

            if (statusEl) statusEl.textContent = status;
            if (availabilityEl) availabilityEl.textContent = availability;
            if (window.meta.page.pageType === 'product') {
                window.updateOfferContentHeights?.();
            }
        }).catch(err => {
            console.error("Failed to get store status or availability:", err);
        });
    }


    if (window.meta.page.pageType === 'product') {
        document.addEventListener("product-variants-resolved", function(e) {
            if (e.detail === "resolved") {
                if (!window.isGoPuffPDPVariantAvailable) { // Remove gopuff tabs on pdp
                    document.querySelector('.gopuff__selector')?.remove();
                    document.querySelector('.product__price')?.classList.remove('mt-0');
                }
            }
        });
    }
}

function editGopuffAddressBtn() {

    const editAddress = document.querySelector('.gopuff__details-address .edit');
    editAddress.addEventListener('click', function (e) {
        const popup = document.getElementById('state-selector-popup');
        if (popup) popup?.classList.remove('d-none');
    });
}

function openEditAddress(openForm) {
    const popup = document.getElementById('state-selector-popup');
    if (popup) popup?.classList.remove('d-none');
    showManualAddressForm();

    if (openForm) {
        deliveryChange();
    }
}

async function validateCurrentCart() {
    const appProxyUrl = '/apps/teacher/validate';
    const errorMessage = "Your selected location doesn’t match your cart items. <br>Some products may be removed during checkout.";
    const errorElement = document.querySelector('.cart-drawer-message');

    // Fetch cart
    const productXHandle = '_gopuff_product';
    const cartRes = await fetch('/cart.js');
    if (!cartRes.ok) {
        console.warn(`Failed to fetch cart. Status: ${cartRes.status}`);
        return;
    }

    const cart = await cartRes.json();

    // Check if any cart item has this property
    const productXInCart = cart.items.some(
        item => item.properties && item.properties[productXHandle]
    );

    if (!productXInCart) {
        // console.log('No gopuff product the in cart');
        return;
    }

    // Get location ID from localStorage
    let locationId = null;
    const statusJSON = localStorage.getItem('delivery-address-status');
    if (statusJSON) {
        try {
            const status = JSON.parse(statusJSON);
            if (typeof status.id === 'number') {
                locationId = status.id;
            }
        } catch {
            console.warn('Invalid JSON in delivery-address-status');
        }
    }

    const validateRes = await fetch(appProxyUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            cart,
            locationId,
        }),
    });


    const result = await validateRes.json();
    // console.log("Cart validation result:", result.error);

    if (result.error && result.error === "No valid GoPuff products found in cart.") {
        return
    }

    // Display cart drawer error message if error 500
    if (!validateRes.ok) {
        console.warn(`Cart validation request failed. Status: ${validateRes.status}`);
        errorElement.innerHTML = errorMessage;
        errorElement.classList.remove('d-none');
        return;
    }


    // Display cart drawer error message not valid
    if (result.gopuffResult && result.gopuffResult.valid === false) {
        errorElement.innerHTML = errorMessage; // Set your error message
        errorElement.classList.remove('d-none');
        return;
    }

    // Hide error if valid
    errorElement.innerHTML = '';
    errorElement.classList.add('d-none');
}

async function getWorkingHours() {
    try {
        // Get the delivery address status from localStorage
        const status = JSON.parse(localStorage.getItem('delivery-address-status') || '{}');
        const locationId = status.id;

        if (!locationId) {
            throw new Error("Location ID not found in localStorage.");
        }

        const response = await fetch(`/apps/teacher/gopuff-working-hours?location=${locationId}`, {
            method: "GET",
            headers: {
                "Accept": "application/json",
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Failed to fetch working hours");
        }

        const data = await response.json();
        // console.log("Working hours:", data);
        localStorage.setItem('delivery-address-working-hours', JSON.stringify(data));

        return data;
    } catch (error) {
        console.error("Fetch error:", error.message);
        throw error;
    }
}

function formatDuration(minutes) {
    if (minutes < 60) {
        return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (mins === 0) {
        return `${hours} hour${hours !== 1 ? 's' : ''}`;
    }
    return `${hours} hour${hours !== 1 ? 's' : ''} and ${mins} minute${mins !== 1 ? 's' : ''}`;
}

function parseTimeToDate(timeStr, baseLocalDate) {
    const [h, m] = timeStr.split(":").map(Number);
    const d = new Date(baseLocalDate.getTime());
    d.setHours(h, m, 0, 0);
    return d;
}

function formatTime(timeStr) {
    const [hour, minute] = timeStr.split(":").map(Number);
    const ampm = hour >= 12 ? "pm" : "am";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12}${minute !== 0 ? ":" + String(minute).padStart(2, '0') : ""}${ampm}`;
}

function getStoreStatusAndAvailability(workingHoursData) {
    const buyButtonEl = document.querySelector('.offer-gopuff .gopuff-pdp-price-selector__button');
    const isGopuffVariantResolved = !!document
        .querySelector('.product-price-data.product-price-data-pdp-gopuff')
        ?.getAttribute('data-regular');

    if (!workingHoursData?.delivery_hours) {
        if (buyButtonEl) buyButtonEl.disabled = true;
        return {
            status: "Store is CLOSED.",
            availability: "Availability information unavailable."
        };
    }

    const { delivery_hours, current_local_weekday, current_local_time } = workingHoursData;

    const now = new Date(current_local_time);
    // console.log("Current Local Time:", current_local_time);

    const todayHours = delivery_hours.find(d => d.day_of_week === current_local_weekday);
    let statusClass = null;

    if (!todayHours?.times.length) {
        if (buyButtonEl) buyButtonEl.disabled = true;
        return {
            status: "Store is CLOSED.",
            availability: "Availability information unavailable."
        };
    }

    let currentRange = null;

    for (const range of todayHours.times) {
        let start = new Date(current_local_time);
        let [sh, sm] = range.start.split(":").map(Number);
        start.setUTCHours(sh, sm, 0, 0);
        let end = new Date(current_local_time);
        let [eh, em] = range.end.split(":").map(Number);
        end.setUTCHours(eh, em, 0, 0);
        if (end <= start) end.setUTCDate(end.getUTCDate() + 1);
        if (now >= start && now <= end) {
            currentRange = { ...range, startDate: start, endDate: end };
            break;
        }
    }

    let statusText = "";

    if (currentRange) {
        const minutesUntilClose = Math.round((currentRange.endDate - now) / 60000);

        // console.log("Next Closing Time:", currentRange.endDate.toISOString());
        // console.log("Minutes until close:", minutesUntilClose);
        // console.log("Hours until close:", (minutesUntilClose / 60).toFixed(2));

        statusText = `Store is currently OPEN. Closes in ${formatDuration(minutesUntilClose)}.`;
        statusClass = "open";

        if (buyButtonEl) buyButtonEl.disabled = !isGopuffVariantResolved;
        if (!isGopuffVariantResolved) statusText = null;

    } else {
        if (buyButtonEl) buyButtonEl.disabled = true;

        const futureRanges = todayHours.times
            .map(range => {
                let startDate = new Date(current_local_time);
                let [sh, sm] = range.start.split(":").map(Number);
                startDate.setUTCHours(sh, sm, 0, 0);

                let endDate = new Date(current_local_time);
                let [eh, em] = range.end.split(":").map(Number);
                endDate.setUTCHours(eh, em, 0, 0);

                if (endDate <= startDate) endDate.setUTCDate(endDate.getUTCDate() + 1);
                return { startDate, endDate, ...range };
            })
            .filter(r => r.startDate > now)
            .sort((a, b) => a.startDate - b.startDate);

        if (futureRanges.length) {
            const nextOpen = futureRanges[0];
            const minutesUntilOpen = Math.round((nextOpen.startDate - now) / 60000);

            // console.log("Next Opening Time:", nextOpen.startDate.toISOString());
            // console.log("Minutes until open:", minutesUntilOpen);
            // console.log("Hours until open:", (minutesUntilOpen / 60).toFixed(2));

            statusText = `Store is CLOSED. Opens in ${formatDuration(minutesUntilOpen)}.`;
        } else {
            let searchDay = (current_local_weekday + 1) % 7;
            let searched = 0;
            let nextOpenInfo = null;
            while (!nextOpenInfo && searched < 7) {
                const dayHours = delivery_hours.find(d => d.day_of_week === searchDay);
                if (dayHours?.times?.length) {
                    const base = new Date(current_local_time);
                    const dayDiff = (searchDay - current_local_weekday + 7) % 7;
                    base.setUTCDate(base.getUTCDate() + dayDiff);
                    const first = dayHours.times[0];
                    let startDate = new Date(base);
                    let [sh, sm] = first.start.split(":").map(Number);
                    startDate.setUTCHours(sh, sm, 0, 0);
                    let endDate = new Date(base);
                    let [eh, em] = first.end.split(":").map(Number);
                    endDate.setUTCHours(eh, em, 0, 0);
                    if (endDate <= startDate) endDate.setUTCDate(endDate.getUTCDate() + 1);
                    nextOpenInfo = { startDate };
                }
                searchDay = (searchDay + 1) % 7;
                searched++;
            }

            if (nextOpenInfo) {
                const minutesUntilOpen = Math.round((nextOpenInfo.startDate - now) / 60000);

                // console.log("Next Opening Time:", nextOpenInfo.startDate.toISOString());
                // console.log("Minutes until open:", minutesUntilOpen);
                // console.log("Hours until open:", (minutesUntilOpen / 60).toFixed(2));

                statusText = `Store is CLOSED. Opens in ${formatDuration(minutesUntilOpen)}.`;
            } else {
                statusText = "Store is CLOSED. Opening hours unavailable.";
            }
        }
    }

    const availabilityRanges = todayHours.times.map(t => `from ${t.start} to ${t.end}`);
    const availabilityText = `Available ${availabilityRanges.join(", ")}.`;

    return {
        status: statusText,
        statusClass,
        availability: availabilityText
    };
}

function clearDeliveryData() {
    localStorage.removeItem('delivery-address');
    localStorage.removeItem('delivery-address-coordinates');
    localStorage.removeItem('delivery-address-full');
    localStorage.removeItem('delivery-address-status');
    localStorage.removeItem('delivery-address-working-hours');
}